import React, { Component } from 'react';
import { Container,Accordion,Icon } from 'semantic-ui-react';
import { PtInput, PtInputIcon, PtInputIconElevation, EditGeographicPoint, PtSelect,PtDateInput } from '../../grit-utilities';
import DropdownLib from '../../DropdownLib';
import 'semantic-ui-css/semantic.min.css';
import '../../index.css';
import ScrollArea from 'react-scrollbar';

/* Note 
The point tab has been designed in such a way that this component is used for Minor Structure Location and Sign Layer Location. 
If this component needs to be added for other layers in future please make sure to pass in the layerId and create an else-if condition to render that layer
Minor Structure supermodel doesn't pass the layerId which is why the render of Minor Structure Location tab should always be in the else condition unless you want 
to fix the model by passing the layerId with all the code refactoring needed for Minor Structure Location tab. 
*/

export default class PointTab extends Component {
    constructor(props) {
        super(props);
        this.state = this.props.pointModel;
        console.log(this.state.layer)


        
    }
    
    
    renderGritLayerUI=()=> {
        // The if condition renders Location tab for Sign Layer
        if (this.props.pointModel.layer === 6){
            const {directionOptions} = DropdownLib.getDropdowns().Signs_Panel
            const {onClickSinglePoint} = this.props.clickFunctions
            const pointState = (pos) => {
                const point = `${pos.lat}, ${pos.lng}`;
                this.setState({ [point.point]: point });
                this.props.pointModel.point.point = point;
            };
            
            return (
                <Container>
                     <ScrollArea
                        speed={1}
                        className={!window.mobileAndTabletcheck() ? "area_desktop" : "area_mobile"}
                        contentClassName="content"
                        smoothScrolling={true}>
                            <PtInputIcon inputColor="pt-intent-primary" disabled={this.props.disabled}
                                icon={<a className="grow pt-icon pt-icon-map-marker"
                                    onClick={() => {
                                        onClickSinglePoint(pointState);
                                        this.props.triggerNeedSave();
                                    }}
                                    style={{
                                        color: '#2385C1' }}></a>}
                                value={this.state.point.point}
                                edit={<EditGeographicPoint originalCoords={this.state.point.point} updateCoordinate={(cp) => { onClickSinglePoint(pointState, cp); this.props.triggerNeedSave(); }} />}
                                label="Sign Location Point" />

                            <PtInput label="Sign Local Panel Number" value={this.state.point.signPanelId} disabled={this.props.disabled}
                                name="signPanelId" onChange={this.onSignInputChange} placeHolder="Sign Panel Id" type="text"/>
    
                            <PtInput label="Location Note" value={this.state.point.locationNote} disabled={this.props.disabled}
                                name="locationNote" onChange={this.onSignInputChange} placeHolder="Location Note" type="text"/>

                            <Accordion fluid>
                                <Accordion.Title className="accordion-title">
                                    <Icon name='dropdown' />
                                    Location Details
                                </Accordion.Title>
                                <Accordion.Content>

                                        <PtInput label="Road Name" value={this.state.LocationDetails.roadName===null?'':this.state.LocationDetails.roadName} disabled={this.props.disabled}
                                        name="roadName" onChange={this.onlocdetailsInputChange} placeHolder="Road Name" type="text"/> 

                                        <PtInput label="Start Road Name" value={this.state.LocationDetails.roadStart===null?'':this.state.LocationDetails.roadStart} disabled={this.props.disabled}
                                            name="roadStart" onChange={this.onlocdetailsInputChange} placeHolder="Road Start" type="text"/>

                                        <PtInput label="End Road Name" value={this.state.LocationDetails.roadEnd===null?'':this.state.LocationDetails.roadEnd} disabled={this.props.disabled}
                                            name="roadEnd" onChange={this.onlocdetailsInputChange} placeHolder="Road End" type="text"/>

                                        <PtInput label="Station" value={this.state.LocationDetails.station===null?'':this.state.LocationDetails.station} disabled={this.props.disabled}
                                        name="station" onChange={this.onlocdetailsInputChange} placeHolder="Station" inputType="number"/>

                                        <PtSelect options={directionOptions}
                                            label="Side" 
                                            defaultVal={this.state.LocationDetails.side===null? 0:this.state.LocationDetails.side}
                                            onChange={this.onLocChangeDropdown} name="side" disabled={this.props.disabled} />     

                                         <PtInput label="Offset from Edgeline" value={this.state.LocationDetails.offSet===null?'':this.state.LocationDetails.offSet} disabled={this.props.disabled}
                                        name="offSet" onChange={this.onlocdetailsInputChange} placeHolder="Offset" inputType="number"/>

                                     

                                </Accordion.Content>
                            </Accordion>
                    </ScrollArea>
                </Container>
            )
        }
        // The else condition renders Location tab for Minor Structure Layer
        else
        {
            const { aprchOption} = DropdownLib.getDropdowns().MS_Approach;
            const { onClickInletPoint, onClickOutletPoint, onClickSinglePoint} = this.props.clickFunctions;
            //const {onClickPoint} = this.props.clickFunctions;
            const pointState = (pos) => {
                const point = `${pos.lat}, ${pos.lng}`;
                console.log(point)
                this.setState({ point: point });
                this.props.pointModel.point = point;
            };
            const inletState = (pos) => {
                const point = `${pos.lat}, ${pos.lng}`;
                this.setState({ inlet: point });
                this.props.pointModel.inlet = point;
            };
            const outletState = (pos) => {
                const point = `${pos.lat}, ${pos.lng}`;
                this.setState({ outlet: point });
                this.props.pointModel.outlet = point;
            };
            return (
                <Container>
                    <PtInput label="Structure Number" value={this.state.structureNumber} disabled={this.props.disabled}
                        name="structureNumber" onChange={this.onInputChange} placeHolder="Structure # or Id" type="text"/>
    
                    <PtInputIcon inputColor="pt-intent-primary" disabled={this.props.disabled}
                        icon={<a className="grow pt-icon pt-icon-map-marker"
                            onClick={() => {
                                onClickSinglePoint(pointState);
                                this.props.triggerNeedSave();
                            }}
                            style={{
                                color: '#2385C1' }}></a>}
                        value={this.state.point}
                        edit={<EditGeographicPoint originalCoords={this.state.point} updateCoordinate={(cp) => { onClickSinglePoint(pointState, cp); this.props.triggerNeedSave(); }} />}
                        label="Center Location" />
    
                    <div className="pt-input-group special-input-group">
                        <PtInputIconElevation inputColor="pt-intent-success" disabled={this.props.disabled}
                            icon={<a className="grow pt-icon pt-icon-map-marker"
                                onClick={() => {
                                    onClickInletPoint(inletState);
                                    this.props.triggerNeedSave();
                                }}
                                style={{
                                    color: '#0A6640'
                                }}></a>}
                            value={this.state.inlet}
                            valueElevation={this.state.inletElevation}
                            onChange={this.onInputChange}
                            name="inletElevation"
                            edit={<EditGeographicPoint originalCoords={this.state.inlet} updateCoordinate={(cp) => { onClickInletPoint(inletState, cp); this.props.triggerNeedSave(); }} />}
                            label="Inlet Location" />
    
                        <PtInputIconElevation inputColor="pt-intent-warning" disabled={this.props.disabled}
                            icon={<a className="grow pt-icon pt-icon-map-marker"
                                onClick={() => {
                                    onClickOutletPoint(outletState);
                                    this.props.triggerNeedSave();
                                }}
                                style={{
                                    color: '#A66321'
                                }}></a>}
                            value={this.state.outlet}
                            valueElevation={this.state.outletElevation}
                            onChange={this.onInputChange}
                            name="outletElevation"
                            edit={<EditGeographicPoint originalCoords={this.state.outlet} updateCoordinate={(cp) => { onClickOutletPoint(outletState, cp); this.props.triggerNeedSave(); }} />}
                            label="Outlet Location" />
                    </div>
                    <PtSelect label="Structure Position" options={aprchOption} onChange={this.onChangeDropdown} disabled={this.props.disabled}
                                    defaultVal={this.state.approachStruct} name="approachStruct" />
    
                    <PtInput label="Point Description" value={this.state.pointDescription} disabled={this.props.disabled}
                        name="pointDescription" onChange={this.onInputChange} placeHolder="Description" type="text"/>
                    {/*<ScrollArea
                        speed={1}
                        className={!window.mobileAndTabletcheck() ? "route_area_desktop" : "route_area_mobile"}
                        contentClassName="content"
                        smoothScrolling={true}>
                    </ScrollArea>*/}
                </Container>
            );

        }
        
    }

    render() {
        return this.renderGritLayerUI();
    }
    
    onChangeDropdown = (e) => {
        const { target } = e;
        const {name, value} = target;
        console.log(name)
        console.log(value)
        this.props.triggerNeedSave();
        // eslint-disable-next-line
        this.setState({ [name]: parseInt(value) });
        // eslint-disable-next-line
        this.props.pointModel[name]=parseInt(value)
        console.log(this.state)
    }

    onLocChangeDropdown  = (e) => {
        const { target } = e;
        const {name, value} = target;
        this.props.triggerNeedSave();

        this.setState({ [name]: parseInt(value) });

        this.props.pointModel.LocationDetails[name]=parseInt(value)
    }
   /* getStructOptions = ()=>{
        fetch(`${config.server}/dropdown/`)
        .then(response=>
            {
                return response.json();
            })
        .then(data=>{
            console.log("DropDown",data.)
        })
    }*/
	onSignInputChange = (e) => {
        const { name, value } = e.target;

        this.props.triggerNeedSave();

        this.setState({ [name]: value });
        this.props.pointModel.point[name] = value;
    }

    onInputChange = (e) => {
        const { name, value } = e.target;

        this.props.triggerNeedSave();

        this.setState({ [name]: value });
        this.props.pointModel[name] = value;

        //console.log(e.target);

    }
    onlocdetailsInputChange = (e) => {
        const { name, value } = e.target;

        this.props.triggerNeedSave();

        this.setState({ [name]: value });
        this.props.pointModel.LocationDetails[name] = value;
        
    }
    
    
}


// WEBPACK FOOTER //
// ./src/layers/tabs/point-tab.js